import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export enum CameraDirection {
    UNKNOWN_CAMERA_DIRECTION = 0,
    FRONT = 1,
    BACK = 2,
    UNRECOGNIZED = -1
}
export enum CameraContext {
    UNKNOWN_CAMERA_CONTEXT = 0,
    MAIN = 1,
    REPLY = 2,
    PROFILE = 3,
    UNRECOGNIZED = -1
}
export enum CameraApi {
    UNKNOWN_CAMERA_API = 0,
    CAMERA_1 = 1,
    CAMERA_2 = 2,
    ARCORE = 3,
    UNRECOGNIZED = -1
}
export enum FlashState {
    UNKNOWN_FLASH_STATE = 0,
    FLASH_ON = 1,
    FLASH_OFF = 2,
    UNRECOGNIZED = -1
}
export enum NightModeState {
    UNKNOWN_NIGHT_MODE_STATE = 0,
    NIGHT_MODE_ON = 1,
    NIGHT_MODE_OFF = 2,
    UNRECOGNIZED = -1
}
export enum PictureMode {
    UNKNOWN_PICTURE_MODE = 0,
    JPEG_PICTURE_MODE = 1,
    GPU_PICTURE_MODE = 2,
    UNRECOGNIZED = -1
}
export enum CaptureMode {
    UNKNOWN_CAPTURE_MODE = 0,
    DEFAULT_CAPTURE_MODE = 1,
    TIMELINE_CAPTURE_MODE = 2,
    UNRECOGNIZED = -1
}
export enum Camera2Level {
    UNKNOWN_CAMERA2_LEVEL = 0,
    LEGACY = 1,
    LIMITED = 2,
    FULL = 3,
    LEVEL_3 = 4,
    UNRECOGNIZED = -1
}
export interface CameraSignals {
    cameraDirection: CameraDirection;
    cameraContext: CameraContext;
    cameraApi: CameraApi;
    flashState: FlashState;
    camera2Level: Camera2Level;
    nightModeState: NightModeState;
    isFirstCapture: boolean;
    pictureMode: PictureMode;
    captureMode: CaptureMode;
    hasLens: boolean;
    isLowLight: boolean;
    isConcurrentCameraSupported: boolean;
}
function createBaseCameraSignals(): CameraSignals {
    return {
        cameraDirection: 0,
        cameraContext: 0,
        cameraApi: 0,
        flashState: 0,
        camera2Level: 0,
        nightModeState: 0,
        isFirstCapture: false,
        pictureMode: 0,
        captureMode: 0,
        hasLens: false,
        isLowLight: false,
        isConcurrentCameraSupported: false,
    };
}
export const CameraSignals: MessageFns<CameraSignals> = {
    encode(message: CameraSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.cameraDirection !== 0) {
            writer.uint32(8).int32(message.cameraDirection);
        }
        if (message.cameraContext !== 0) {
            writer.uint32(16).int32(message.cameraContext);
        }
        if (message.cameraApi !== 0) {
            writer.uint32(24).int32(message.cameraApi);
        }
        if (message.flashState !== 0) {
            writer.uint32(32).int32(message.flashState);
        }
        if (message.camera2Level !== 0) {
            writer.uint32(40).int32(message.camera2Level);
        }
        if (message.nightModeState !== 0) {
            writer.uint32(48).int32(message.nightModeState);
        }
        if (message.isFirstCapture !== false) {
            writer.uint32(56).bool(message.isFirstCapture);
        }
        if (message.pictureMode !== 0) {
            writer.uint32(64).int32(message.pictureMode);
        }
        if (message.captureMode !== 0) {
            writer.uint32(72).int32(message.captureMode);
        }
        if (message.hasLens !== false) {
            writer.uint32(80).bool(message.hasLens);
        }
        if (message.isLowLight !== false) {
            writer.uint32(88).bool(message.isLowLight);
        }
        if (message.isConcurrentCameraSupported !== false) {
            writer.uint32(96).bool(message.isConcurrentCameraSupported);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): CameraSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCameraSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.cameraDirection = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.cameraContext = reader.int32() as any;
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.cameraApi = reader.int32() as any;
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.flashState = reader.int32() as any;
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.camera2Level = reader.int32() as any;
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.nightModeState = reader.int32() as any;
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.isFirstCapture = reader.bool();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.pictureMode = reader.int32() as any;
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.captureMode = reader.int32() as any;
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.hasLens = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.isLowLight = reader.bool();
                    continue;
                }
                case 12: {
                    if (tag !== 96) {
                        break;
                    }
                    message.isConcurrentCameraSupported = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<CameraSignals>, I>>(base?: I): CameraSignals {
        return CameraSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CameraSignals>, I>>(object: I): CameraSignals {
        const message = createBaseCameraSignals();
        message.cameraDirection = object.cameraDirection ?? 0;
        message.cameraContext = object.cameraContext ?? 0;
        message.cameraApi = object.cameraApi ?? 0;
        message.flashState = object.flashState ?? 0;
        message.camera2Level = object.camera2Level ?? 0;
        message.nightModeState = object.nightModeState ?? 0;
        message.isFirstCapture = object.isFirstCapture ?? false;
        message.pictureMode = object.pictureMode ?? 0;
        message.captureMode = object.captureMode ?? 0;
        message.hasLens = object.hasLens ?? false;
        message.isLowLight = object.isLowLight ?? false;
        message.isConcurrentCameraSupported = object.isConcurrentCameraSupported ?? false;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
